import { render } from "./PosClaimDetails.vue?vue&type=template&id=2400572d"
import script from "./PosClaimDetails.vue?vue&type=script&lang=js"
export * from "./PosClaimDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__